import React, { useEffect } from 'react'
import Snapshot from './ScheduleDetailPage/Snapshot'
import { Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  GetSchedulerReportId,
} from './reportSlices/reportAnalytics'
import ReportPageSchedulerHeader from './ReportPageSchedulerHeader'
import { useGetCampaignReportScheduleDetailsQuery } from '../../../../services/cellcast'

const ReportPageSchedulerWrapper = () => {
  const ReportId = useSelector(GetSchedulerReportId)
  const { data, isFetching } = useGetCampaignReportScheduleDetailsQuery({ campId: ReportId?.id })

  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <ReportPageSchedulerHeader />
            </>
          }
        >
          <Route index element={<Navigate to='*/scheduler/snapshot' replace={true} />} />
          <Route
            path='snapshot'
            element={
              <>
                <Snapshot />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default ReportPageSchedulerWrapper
